"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePagination = void 0;
var table_pagination_component_1 = require("./table-pagination.component");
Object.defineProperty(exports, "TablePagination", { enumerable: true, get: function () { return table_pagination_component_1.TablePagination; } });
